/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const cookieModalStyle = {
  divider: {
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
  },
  headline: {
    marginBottom: "0.5rem",
  },
};

export default cookieModalStyle;
